import { render, staticRenderFns } from "./partnerRoutee.vue?vue&type=template&id=1ebfb788"
import script from "./partnerRoutee.vue?vue&type=script&lang=js"
export * from "./partnerRoutee.vue?vue&type=script&lang=js"
import style0 from "./partnerRoutee.vue?vue&type=style&index=0&id=1ebfb788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports